import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

// Positions are only as fresh as devices flush telemetry (~1s) — polling
// faster than that just re-reads the same rows. Same monitoring-surface
// rationale as useTeamLiveWall: keep polling while the tab is unfocused.
export const TEAM_LIVE_POSITIONS_POLL_INTERVAL_MS = 1_000;

export function useTeamLivePositions(teamId: string, enabled = true) {
  return useQuery({
    queryKey: ["team-live-positions", teamId],
    queryFn: () => apiClient.getTeamLivePositions(teamId),
    enabled: !!teamId && enabled,
    refetchInterval: TEAM_LIVE_POSITIONS_POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
  });
}
